import { useId, useRef } from "react";
import { useModalLayer, useSubmitGuard } from "../../modals/modalHooks";
import { Button } from "../../ui";

// The Menu page's dialog shell: existing .food-modal styling plus the shared
// modal behaviour (Escape, focus return, scroll lock, double-submit guard).
export default function MenuDialog({ title, children, onClose, onSubmit, submitLabel, cancelLabel, submitDisabled = false, wide = false, error = "" }) {
  const ref = useRef(null);
  const titleId = useId();
  const [busy, run] = useSubmitGuard();
  useModalLayer(true, { containerRef: ref, onEscape: () => !busy && onClose() });
  return (
    <div className="food-modal-overlay">
      <div ref={ref} tabIndex={-1} className={`food-modal menu-dialog ${wide ? "menu-dialog-wide" : ""}`} role="dialog" aria-modal="true" aria-labelledby={titleId} aria-busy={busy || undefined}>
        <h3 id={titleId}>{title}</h3>
        {children}
        {error && (
          <p className="menu-error" role="alert">
            {error}
          </p>
        )}
        <div className="food-modal-actions">
          {onSubmit && (
            <Button type="button" variant="primary" appearance="filled" disabled={submitDisabled || busy} loading={busy} onClick={() => run(onSubmit)}>
              {submitLabel}
            </Button>
          )}
          <Button type="button" variant="warning" appearance="soft" disabled={busy} onClick={onClose}>
            {cancelLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
